export class VibrationsSave {
  id: string;
  fileName: string;
  siteId: number;
  tirId: number;
  controlPointId: number;

  picVibration?: number;
  surpression?: number;
  distance?: number;
  numeroPtControl?: number;
  idVibrationMaria?: number;
}
